import { model as NotificationsModel } from "@/data-models/app-notifications.mjs";
import { featureFlagModel } from "@/data-models/feature-flags.mjs";
import gql from "@/util/graphql-query.mjs";

export const Notifications = gql`
query Notifications {
    notifications { ${NotificationsModel} }
  }
`;

export const FeatureFlags = gql`
query FeatureFlags {
    featureFlags { ${featureFlagModel} }
  }
`;
